import React, { useRef } from "react";
import Info from "../common/info";
import { OptionsContainer } from "../../styled/setting";
import { FaCheckCircle } from "react-icons/fa";
import { formatQuantity, status } from "../../function/store";
import ActionButtons from "../../setting/common/actionButtons";
import axios from "axios";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";

const Options = ({
  transformValue,
  data,
  changeTab,
  context,
  setContext,
  openModal,
  closeModal,
  getOptions,
  selectCompany,
  toggleModal,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  // 옵션 그룹 상태 변경
  const updateOption = (type, item) => {
    if (item.status === type) return;

    const isGroup = Boolean(item?.options);
    const target = isGroup ? item : data.find((opt) => opt.id === item.optionGroupId);

    const body = {
      id: target.id,
      name: target.name,
      isRequired: target.isRequired,
      cmpnyNo: selectCompany.value,
      status: isGroup ? type : target.status,
      ...(isGroup
        ? {}
        : {
            options: target.options.map((opt) => ({
              id: opt.id,
              value: opt.value,
              addPrice: opt.addPrice,
              quantity: opt.quantity,
              status: opt.id === item.id ? type : opt.status,
            })),
          }),
    };

    openModal({
      type: "confirmation",
      title: isGroup ? "옵션 그룹 상태 변경" : "옵션 상태 변경",
      message: [
        `${isGroup ? `${item.name} 옵션 그룹을` : `${item.value} 옵션을`}`,
        `${status[type]} 상태로 변경하시겠습니까?`,
      ],
      handleConfirm: () =>
        submitUpdate(body, `${isGroup ? "옵션 그룹의" : "옵션의"} 상태가 변경되었습니다.`),
      handleCancel: () => closeModal(),
    });
  };

  // 옵션 삭제
  const removeOption = async (optionGroupId, optionId) => {
    const url = "/erp/option/delete";
    const body = { optionGroupId, optionId, cmpnyNo: selectCompany.value };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("옵션이 삭제되었습니다.");
        await getOptions();
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      setContext(null);
      closeModal();
    }
  };

  // 옵션 그룹 삭제
  const removeGroup = async (optionGroupId) => {
    const url = "/erp/optionGroup/delete";
    const body = { optionGroupId, cmpnyNo: selectCompany.value };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("옵션 그룹이 삭제되었습니다.");
        await getOptions();
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      setContext(null);
      closeModal();
    }
  };

  const submitUpdate = async (input, message) => {
    const url = "/erp/optionGroup/update";
    const body = { input };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success(message);
        await getOptions();
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      setContext(null);
      closeModal();
    }
  };

  return (
    <OptionsContainer
      className="slideContent"
      style={{ transform: `translateX(${transformValue}%)` }}>
      <Info
        message={`옵션 그룹 **${data.length}**개`}
        actions={[{ label: "추가", func: () => changeTab(1), key: "add" }]}
      />
      <div className="contents">
        {data && data.length > 0 ? (
          <ul className="optionGroups">
            {data.map((item) => (
              <li key={item.id}>
                <div className="option">
                  <span className="name">{item.name}</span>
                  <ActionButtons
                    context={context}
                    setContext={setContext}
                    item={item}
                    highlight={true}
                    changeStatus={(type, item) => updateOption(type, item)}
                    buttons={[
                      { label: "수정", onClick: () => changeTab(2, item) },
                      {
                        label: "삭제",
                        onClick: () =>
                          openModal({
                            type: "confirmation",
                            title: "옵션 그룹 삭제",
                            message: [
                              `${item.name} 옵션 그룹을 삭제하시겠습니까?`,
                              "해당 옵션 그룹에 포함된 모든 옵션도 함께 삭제됩니다.",
                            ],
                            handleConfirm: () => removeGroup(item.id),
                          }),
                      },
                    ]}
                  />
                </div>
                <div className="required">
                  <span className="tit">
                    <FaCheckCircle />
                    옵션그룹코드
                  </span>
                  <span className="cont">{item.id}</span>
                </div>
                <div className="required">
                  <span className="tit">
                    <FaCheckCircle />
                    유형
                  </span>
                  <span className="cont">
                    {item.isRequired
                      ? "필수옵션 (필수 1개 선택)"
                      : "선택옵션 (선택하지 않아도 주문이 가능합니다.)"}
                  </span>
                </div>
                <div className="products">
                  <span className="tit">
                    <FaCheckCircle />
                    연결상품{item.linkedProducts.length > 0 && ` (${item.linkedProducts.length}개)`}
                  </span>
                  <div className="cont">
                    {item.linkedProducts && item.linkedProducts.length > 0 ? (
                      item.linkedProducts.map((prd, index) => (
                        <span key={index} className="linked-product">
                          {prd.name}
                          {index !== item.linkedProducts.length - 1 && !isMobile && ", "}
                        </span>
                      ))
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                  <button onClick={() => toggleModal(item)}>상품연동</button>
                </div>
                <ul className="options">
                  {item.options.map((opt) => (
                    <li key={opt.id}>
                      <div>
                        <span className="value">{opt.value}</span>
                        <span>옵션코드 {opt.id}</span>
                        {opt.quantity !== -1 && <span>재고 {formatQuantity(opt.quantity)}</span>}
                        <span>추가요금 {formatNumber(opt.addPrice)}원</span>
                      </div>
                      <ActionButtons
                        context={context}
                        setContext={setContext}
                        item={opt}
                        parentId={item.id}
                        changeStatus={(type, item) => updateOption(type, item)}
                        buttons={[
                          {
                            label: "삭제",
                            onClick: () => {
                              if (item.options.length === 1) {
                                toast.error("옵션 그룹에는 최소 1개의 옵션이 필요합니다.");
                                return;
                              }
                              openModal({
                                type: "confirmation",
                                title: "옵션 삭제",
                                message: [`${opt.value} 옵션을 삭제하시겠습니까?`],
                                handleConfirm: () => removeOption(item.id, opt.id),
                              });
                            },
                          },
                        ]}
                      />
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        ) : (
          <>옵션 그룹이 존재하지 않습니다.</>
        )}
      </div>
    </OptionsContainer>
  );
};

export default Options;
